import React, { Component } from 'react';
import {
    CCard,
    CCardBody,
    CCardGroup,
    CForm,
    CCol,
    CFormInput,
    CFormLabel,
    CRow,
    CFormCheck,
    CFormSelect
} from '@coreui/react';
import AppButton from 'src/components/AppButton'
import {
    cilSave
} from '@coreui/icons'
import ServerConnector from 'src/ServerConnector'
import PageHeader from 'src/components/PageHeader'

class AddMentor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user_seq: this.props.page_data.user_seq,
            pageNamePrefix: this.props.page_data.user_seq == -999 ? "Add" : "Edit",
            coordinator_list: [],
            inputs: {
                email: "",
                emailerr: "",
                name: "",
                nameerr: "",
                user_password: "",
                user_passworderr: "",
                is_coordinator: "NO",
                coordinator_seq: -1,
                coordinator_seqerr: ""
            }
        };
    }

    componentDidMount() {

        this.loadCoordinatorList();

        if (this.state.user_seq != -999) {

            this.loadMentorData();
        }
    }

    loadMentorData() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MENTOR_DETAILS",
            "user_seq": this.state.user_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            let inputs = this.state.inputs;
            inputs["name"] = data.data[0].name;
            inputs["email"] = data.data[0].email;
            inputs["is_coordinator"] = data.data[0].role == "COORDINATOR" ? "YES" : "NO";
            inputs["coordinator_seq"] = data.data[0].coord_seq;
            this.setState({
                inputs: inputs
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            this.props.showAlert("Error", msg, "Ok", null, () => {
                this.props.navigate("manage_mentors")
            })
        })
    }

    loadCoordinatorList() {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_ALL_MENTORS",
            "filter_role": "COORDINATOR"
        }

        connector.postData(dataMap, (data) => { // success

            var list = [];
            for (var i = 0; i < data.data.length; i++) {

                if (data.data[i].status == "ACTIVE" &&
                    this.state.user_seq != data.data[i].user_seq) {

                    list[list.length] = data.data[i];
                }
            }

            this.setState({
                coordinator_list: list
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                coordinator_list: []
            });
        });
    }

    updateInput(inputName, event) {

        let inputs = this.state.inputs;

        if (inputName == "is_coordinator") {

            inputs["is_coordinator"] = inputs["is_coordinator"] == "YES" ? "NO" : "YES";
        }
        else {

            inputs[inputName] = event.target.value;
            inputs[inputName + "err"] = "";
        }

        this.setState({
            inputs: inputs
        });
    }

    validateForm() {

        var isValid = true;
        let inputs = this.state.inputs;

        if (inputs.name.length == 0) {
            inputs["nameerr"] = "Required";
            isValid = false;
        }

        if (inputs.email.length == 0) {
            inputs["emailerr"] = "Required";
            isValid = false;
        }

        if (this.state.user_seq == -999) {

            if (inputs.user_password.length == 0) {
                inputs["user_passworderr"] = "Required";
                isValid = false;
            }
        }

        if (inputs.is_coordinator == "NO") {

            if (inputs.coordinator_seq <= 0) {
                inputs["coordinator_seqerr"] = "Required";
                isValid = false;
            }
        }

        if (!isValid) {
            this.setState({ inputs: inputs });
        }
        else {
            this.props.showConfirmation(
                "Confirmation",
                "Do you want to save this Mentor?",
                "Yes",
                "No",
                null,
                () => { this.submitForm() }
            );
        }
    }

    submitForm() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap;
        if (this.state.user_seq == -999) {
            dataMap = {
                "_action_code": "ADD_MENTOR",
                "name": this.state.inputs.name,
                "email": this.state.inputs.email,
                "user_password": this.state.inputs.user_password,
                "is_coordinator": this.state.inputs.is_coordinator
            }
        }
        else {
            dataMap = {
                "_action_code": "UPDATE_MENTOR",
                "user_seq": this.state.user_seq,
                "name": this.state.inputs.name,
                "email": this.state.inputs.email,
                "is_coordinator": this.state.inputs.is_coordinator
            }
        }

        if (this.state.inputs.is_coordinator == "NO") {
            dataMap["coordinator_seq"] = this.state.inputs.coordinator_seq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {
                this.props.navigate("manage_mentors")
            })
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);

            if (data.data) {

                let inputs = this.state.inputs;

                for (let key in data.data) {

                    inputs[key + "err"] = data.data[key];
                }

                this.setState({
                    inputs: inputs
                });
                return;
            }

            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    render() {
        return (
            <>
                <PageHeader
                    page_name={this.state.pageNamePrefix + " " + this.props.page_name}
                    onBackPressed={() => this.props.navigate("manage_mentors")} />
                <CCardGroup>
                    <CCard className="p-4">
                        <CCardBody>
                            <CForm className="row g-3">
                                <CCol md={6}>
                                    <CFormLabel htmlFor="name">Name *</CFormLabel>
                                    <CFormInput type="text" id="name" maxLength="64"
                                        onChange={(event) => { this.updateInput("name", event) }}
                                        value={this.state.inputs.name} />
                                    <div className="inputError">
                                        {this.state.inputs.nameerr}
                                    </div>
                                </CCol>
                                <CCol md={6}>
                                    <CFormLabel htmlFor="email">Email *</CFormLabel>
                                    <CFormInput type="text" id="email" maxLength="64"
                                        onChange={(event) => { this.updateInput("email", event) }}
                                        value={this.state.inputs.email} />
                                    <div className="inputError">
                                        {this.state.inputs.emailerr}
                                    </div>
                                </CCol>
                                {
                                    this.state.user_seq == -999 ?
                                        <CCol md={6}>
                                            <CFormLabel htmlFor="password">Password *</CFormLabel>
                                            <CFormInput type="text" id="password" maxLength="32"
                                                onChange={(event) => { this.updateInput("user_password", event) }}
                                                value={this.state.inputs.user_password} />
                                            <div className="inputError">
                                                {this.state.inputs.user_passworderr}
                                            </div>
                                        </CCol>
                                        : null
                                }
                                <CCol md={6}>
                                    <CFormLabel></CFormLabel>
                                    <CFormCheck
                                        checked={this.state.inputs.is_coordinator == "YES"}
                                        onChange={(event) => { this.updateInput("is_coordinator", event) }}
                                        label="Is Coordinator?" />
                                </CCol>
                                {
                                    this.state.inputs.is_coordinator != "YES" ?
                                        <CCol md={6}>
                                            <CFormLabel htmlFor="selectSample"> Coordinator *</CFormLabel>
                                            <CFormSelect id="selectSample" value={this.state.inputs.coordinator_seq}
                                                onChange={(event) => { this.updateInput("coordinator_seq", event) }}>
                                                <option value={-1}>Select Coordinator</option>
                                                {
                                                    this.state.coordinator_list.map((object, index) => {
                                                        return (
                                                            <option key={String(index) + object.user_seq} value={object.user_seq}>
                                                                {object.name}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </CFormSelect>
                                            <div className="inputError">
                                                {this.state.inputs.coordinator_seqerr}
                                            </div>
                                        </CCol>
                                        : null
                                }
                                <CRow className="mt-4">
                                    <CCol xs={12} className="alignCenter">
                                        <AppButton
                                            size="md"
                                            name="Submit"
                                            color="primary"
                                            icon={cilSave}
                                            isLoading={false}
                                            onClick={() => this.validateForm()}>
                                            Submit
                                        </AppButton>
                                    </CCol>
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </>
        );
    }
}

export default AddMentor;